module.exports = __webpack_public_path__ + "img/BagicSvg4.a6399405.svg";